import React, { useState, useEffect, useCallback, forwardRef } from "react";
import MaterialTable from "material-table";
import { DeleteOutlined, EditOutlined } from "@material-ui/icons";
import DocumentButton from "../../../components/SubmitDocumentButton";
import IntegrationButton from "../../../components/IntegrationButton/";
import IntegrationValidity from "../../../components/IntegrationButton/integrationValidity";

function Employees(props) {
  const [state, setState] = useState({
    columns: [
      { title: "Nome", field: "name" },
      { title: "CPF", field: "cpf" },
      { title: "Função", field: "FunctionId", lookup: {} }, // 3
      {
        title: "Setor",
        field: "SectorId",
        lookup: {}
      }, // 4
      {
        title: "Status",
        field: "EmployeeStatusId",
        lookup: {},
        editable: "never"
      }, // 5
      {
        title: "Integração",
        render: rowData =>
          IntegrationButton(rowData, props.selectIntegration)
       
      },
      {
        title: "Validade",
        render: rowData =>
        IntegrationValidity(rowData, props.selectIntegration)
       
      },
      {
        title: "Documentos",
        render: rowData => DocumentButton(rowData)
      },
      {
        title: "Editar",
        render: rowData => (
          <EditOutlined
            color="primary"
            onClick={() => {
              props.currentEmployee(rowData);
            }}
          />
        )
      }
    ],
    loading: false,
    isEmail: null
  });

  const fetchMyAPI = useCallback(async () => {
    setState({ ...state, loading: true });
    if (
      props.employees !== null &&
      props.sectors &&
      props.functions &&
      props.status &&
      !undefined
    ) {
      let employees = props.employees;
      let columns = formatResponse( props.sectors, 3);
      let functions = formatResponse( props.functions, 2);
      let status = formatResponse(props.status, 4);

      await setState({
        ...state,
        employees: employees,
        columns: columns,
        functions: functions,
        status: status,
        loading: false
      });
    }
  });

  const formatResponse = (result, position) => {
    let columns = state.columns;
    const indexColumnSector = 3;
    if (result !== null && !undefined) {
      columns[position].lookup = result.reduce((accumulator, currentValue) => {
        accumulator[currentValue.id] =
          position === indexColumnSector
            ? currentValue.name
            : currentValue.description;
        return accumulator;
      }, {});
    }
    return columns;
  };

  useEffect(() => {
    fetchMyAPI();
  }, [props]);

  const tableIcons = {
    Delete: forwardRef((props, ref) => (
      <DeleteOutlined {...props} ref={ref} color="error" />
    ))
  };

  return (
    <>
      {/* Titulo */}
      <div className="row page-titles">
        <div className="col-md-5 col-8 align-self-center">
          <h3 className="text-themecolor">
            Funcionário(s)
            {state.load ? <i className="fa fa-spin fa-spinner"></i> : null}
          </h3>
        </div>
      </div>

      <MaterialTable
        title=""
        isLoading={state.loading}
        icons={tableIcons}
        options={{
          actionsColumnIndex: -1
        }}
        localization={{
          pagination: {
            labelDisplayedRows: "{from}-{to} de {count}",
            labelRowsSelect: "linhas",
            firstTooltip: "Primeira",
            previousTooltip: "Anterior",
            nextTooltip: "Próxima",
            lastTooltip: "Última"
          },
          body: {
            emptyDataSourceMessage: "Não há dados a serem exibidos",
            editRow: {
              saveTooltip: "Salvar",
              cancelTooltip: "Cancelar",
              deleteText: localStorage.getItem("UserTypeId") === "2" 
                ? "Clique para entrar em contato com o CDI sobre este funcionário" 
                : "Tem certeza que deseja deletar este registro?"
            },
            addTooltip: "Adicionar",
            deleteTooltip: localStorage.getItem("UserTypeId") === "2" 
              ? "Contatar CDI" 
              : "Deletar",
            editTooltip: "Editar"
          },
          header: {
            actions: "Deletar"
          },
          toolbar: {
            searchPlaceholder: "Pesquisar"
          }
        }}
        columns={state.columns}
        data={state.employees}
        editable={{
          onRowDelete: async data => {
            // Check if user is type 2 (external user)
            const userType = localStorage.getItem("UserTypeId");
            if (userType === "2") {
              // Show alert message and prevent deletion
              alert("Por Gentileza entre em contato com o CDI para desativar funcionários. (cdi.ssz@dpworld.com) ");
              return Promise.reject(); // This prevents the row from being deleted
            } else {
              // Allow deletion for other user types
              props.deleteEmployee(data);
            }
          }
        }}
      />
    </>
  );
}

export default Employees;
